var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeachAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.28 5.96998L17.42 8.82998C14.29 5.69998 9.90998 4.64998 5.97998 5.94998C9.92998 2.00998 16.33 2.01998 20.28 5.96998ZM14.56 13.13L13.13 14.56L19.57 21L21 19.57L14.56 13.13ZM5.94998 5.97998C2.00998 9.92998 2.01998 16.33 5.96998 20.28L8.82998 17.42C5.69998 14.29 4.64998 9.90998 5.94998 5.97998ZM5.95998 5.96998L5.96998 5.95998C8.97998 5.57998 12.86 7.12998 15.99 10.26L10.26 15.99C7.12998 12.85 5.57998 8.97998 5.95998 5.96998Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachAccess);
export default __webpack_public_path__ + "static/media/beach-access.7e2102ba9705f0015b5aaf5ab12cfdd2.svg";
export { ForwardRef as ReactComponent };